import React from "react";

const WhatsAppMarketing = () => {
  return (
    <section
      className="position-relative"
      style={{
        overflow: "hidden",
        background: "linear-gradient(135deg, #F4F7FC 0%, #E9F1FF 100%)",
      }}
    >
      {/* wrapper aligned to Header container */}
      <div
        className="mx-auto position-relative ws-wrap"
        style={{
          maxWidth: "74%",
        }}
      >
        <div
          className="ws-hero"
          style={{
            display: "grid",
            gridTemplateColumns: "1.1fr 1fr",
            gap: 24,
            alignItems: "stretch",
          }}
        >
          {/* LEFT */}
          <header
            className="fade-up"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <h2
              style={{
                margin: 0,
                lineHeight: 1,
                letterSpacing: "-0.02em",
                color: "#242121ff",
                fontWeight: 700,
                fontSize: "3.6rem",
                fontFamily: "Inter",
              }}
            >
              <span
                style={{
                  display: "block",
                }}
              >
                Conversations that swipe right on ROI
              </span>
              <span
                style={{
                  marginTop: '2rem',
                  display: "block",
                  fontSize: '1.4rem',
                  color: "#484444ff",
                  fontWeight: 350,
                  fontFamily: "Inter",
                  fontStyle: 'italic',
                  lineHeight: 1.2
                }}
              >
                Build lasting connections & higher ROI with WhatsApp marketing automation.
              </span>
            </h2>

            <p
              style={{
                margin: "14px auto 0",
                color: "#413e3eff",
                fontSize: "1.1rem",
                maxWidth: 800,
                fontFamily: "Poppins",
                fontWeight: 300,
                maxWidth: 780,
                lineHeight: 1.2
              }}
            >
              Automate campaigns, send personalized messages and grow your business with the world’s most powerful messaging platform.
            </p>

            {/* CTAs */}
            <div
              className="d-flex gap-3 flex-wrap"
              style={{
                display: "flex",
                gap: 12,
                marginTop: 22,
                flexWrap: "wrap",
              }}
            >
              <a
                href="#demo"
                aria-label="Start free demo"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "12px 20px",
                  borderRadius: 10,
                  background: "#054E91",
                  color: "#f4f2f2ff",
                  textDecoration: "none",
                  fontFamily: "Poppins",
                  fontSize: "18px",
                  fontWeight: 400,
                  cursor: "pointer",
                  lineHeight: 1.2,
                  boxShadow: "0 8px 20px rgba(5,78,145,.18)",
                }}
              >
                Start Free Trial
              </a>

              <div className="btn-animated-border btn-animated-border--pricing">
                <a
                  href="#pricing"
                  aria-label="View pricing"
                  className="btn-inner btn-inner--pricing"
                >
                  Book a Demo
                </a>
              </div>
            </div>

            {/* KEY HIGHLIGHTS — single-line glass cards */}
            {/* <div className="metric-row" role="list" aria-label="Key highlights">
              {["GDPR/DPDP ready", "95% open rates", "Higher conversions"].map(
                (t, i) => (
                  <div
                    role="listitem"
                    className="metric-card"
                    key={t}
                    style={{
                      "--fill": i === 0 ? "100%" : i === 1 ? "95%" : "80%",
                    }}
                  >
                    <div className="metric-text">{t}</div>
                    <div className="meter">
                      <span className="fill" />
                    </div>
                  </div>
                )
              )}
            </div> */}
          </header>

          {/* RIGHT */}
          <div
            className="ws-hero__img fade-right"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: "80px",
              paddingBottom: "80px",
            }}
          >
            <div
              style={{
                width: "624px",
                height: "500px",
                border: "2px solid #5d5d5fff",
                borderRadius: "18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontFamily: "'Inter', sans-serif",
                fontWeight: 600,
                color: "#29445A",
              }}
            >
            </div>
          </div>
        </div>
      </div>

      {/* responsive + animation styles */}
      <style>
        {`
        .ws-wrap{ padding-left:16px; padding-right:16px; }
        @media (min-width: 768px){
          .ws-wrap{ padding-left:24px; padding-right:24px; }
        }

        @media (max-width: 1024px){
          .ws-hero{ grid-template-columns: 1fr; }
          .ws-hero__img{ margin-top: 8px; }
        }
        @media (max-width: 640px){
          .ws-hero h1{
            font-size: 40px !important;
            line-height: 1.08 !important;
          }
        }

        /* Animations */
        @keyframes fadeUp {
          from {opacity:0; transform:translateY(40px);}
          to {opacity:1; transform:translateY(0);}
        }
        @keyframes fadeRight {
          from {opacity:0; transform:translateX(60px);}
          to {opacity:1; transform:translateX(0);}
        }

        .fade-up {
          animation: fadeUp 0.9s ease-out both;
        }
        .fade-right {
          animation: fadeRight 0.9s ease-out both;
        }

          /* REQUIRED: the spinning animation (global once) */
          @keyframes spin{
          0%   { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
         }

        /* Base animated-border wrapper (must exist) */
       .btn-animated-border{
           position: relative;
           display: inline-block;
           padding: 2px;          
           border-radius: 10px;
           overflow: hidden;
           isolation: isolate;    
        }

       .btn-animated-border::before{
           content: "";
           position: absolute;
           inset: 0;
           background: conic-gradient(#4FC3FF, #00E785, #4FC3FF);
           animation: spin 4s linear infinite;
      }

     .btn-animated-border::after{
          content: "";
          position: absolute;
          inset: 2px;             
          background: #fff;
          border-radius: 8px;
          z-index: 0;
      }

/* Pricing variant: only color swap for the ring */
.btn-animated-border--pricing::before{
  background: conic-gradient(#4FC3FF, #2C2C6F, #4FC3FF);
}

/* The inner link sits above the inner fill */
.btn-inner{
  position: relative;
  z-index: 1;
}

/* Pricing text = gradient text (same colors as ring) */
.btn-inner--pricing{
  padding: 8px 20px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  font-family: Poppins;
  font-size: 18px;
  font-weight: 450;
  line-height: 1.2;
  cursor: pointer;

  background: linear-gradient(90deg, #4FC3FF, #2C2C6F);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
}

.metric-row{
  display:flex;
  gap:16px;
  flex-wrap:nowrap;          /* ek hi line */
  overflow-x:auto;           /* chhote screen par scroll */
  padding-bottom:2px;
  -webkit-overflow-scrolling:touch;
  scrollbar-width:none;
}
.metric-row::-webkit-scrollbar{ display:none; }

.metric-card{
  margin-top: 2.7rem;
  border-radius:14px;
  background: rgba(234,244,255,.55);    
  border:1px solid rgba(188,215,255,.60);
  padding: 18px 18px;
}

.metric-text{
  color: #103968ff;             
  font-size: 16px;
  font-weight: 500;
  font-family: Inter;
}

/* progress bar */
.meter{
  height:8px;
  margin-top:10px;
  background:rgba(10,86,162,.18);        
  border-radius:999px;
  overflow:hidden;
}
.meter .fill{
  display:block;
  height:100%;
  width:var(--fill, 80%);                 
  background:linear-gradient(90deg,#1DB954,#18c76a);         /* green fill */
  border-radius:inherit;
  box-shadow:inset 0 0 0 1px rgba(255,255,255,.25);
}

      `}
      </style>
    </section>
  );
};

export default WhatsAppMarketing;
